/* istanbul ignore next */
(function(angular) {
    'use strict';

    angular.module('onvio.setup').config(['$stateProvider', '$urlRouterProvider', 'bmpStateProvider',
        function($stateProvider, $urlRouterProvider, bmpStateProvider) {

            // #research is the client screen really the default setup screen?
            $urlRouterProvider.when('/setup', '/setup/clients');

            $urlRouterProvider.when('/setup/permission-groups/{groupId:[0-9a-fA-F]{32}}', '/setup/permission-groups/edit/:groupId');

            $stateProvider.state('setup-themes', {
                url: '/setup/themes',
                templateUrl: 'setup/src/themes/appearance-setup.2js.html',
                controller: 'AppearanceSetupCtrl as vm',
                resolve: {
                    themeSettings: ['$q', 'ThemeSetupManager', 'AuthenticatedSessionData', function($q, ThemeSetupManager, AuthenticatedSessionData) {
                        // Note: Theme information is loaded here in order to have color picker palettes loaded correctly.
                        return AuthenticatedSessionData.get().then(function(data){
                            var companyId = data.bindings.ApplicationConfiguration.CompanyId;
                            var promises = [];
                            promises.push(ThemeSetupManager.getFirmThemeSettings(companyId));
                            promises.push(ThemeSetupManager.getDefaultThemeSettings(companyId));
                            return $q.all(promises).then(function(results) {
                                return {
                                    firmSettings: results[0],
                                    defaultThemeData: results[1]
                                };
                            }, function(){
                                return undefined;
                            });
                        }, function(){
                            return undefined;
                        });
                    }],
                    permission: ['$state', 'bmPermission', 'bmAccess', function($state, bmPermission, bmAccess) {
                        bmPermission.has('Platform.ccVnext').then(function() {
                            $state.go('setup-themes-next', {}, { location: 'replace' });
                        }).catch(function() {
                            bmAccess.has('ClientCenterVnext').then(function() {
                                $state.go('setup-themes-next', {}, { location: 'replace' });
                            }).catch(function() { angular.noop(); });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-themes-next', {
                url: '/setup/themes-next',
                templateUrl: 'setup/src/themes/theme-setup-next.html',
                resolve: {
                    permission: ['$state', 'bmPermission', 'bmAccess', function($state, bmPermission, bmAccess) {
                        bmPermission.has('Platform.ccVnext').catch(function() {
                            bmAccess.has('ClientCenterVnext').catch(function() {
                                $state.go('setup-themes', {}, { location: 'replace' });
                            });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-setting-security', {
                url: '/setup/setting-security',
                templateUrl: 'setup/src/security/setting-security.html',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.OnvioSecurity').then(function() {}).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-terms', {
                url: '/setup/terms',
                templateUrl: 'setup/src/terms/terms.html',
                controller: 'onvio.setup.terms.TermsAndConditionsController as vm',
                resolve: {
                    permission: ['$state', 'bmAccess', function($state, bmAccess) {
                        bmAccess.not('PlatformHideTermsAndConditions').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('bm-notifications', {
                url: '/setup/notifications',
                templateUrl: 'setup/src/bm-notifications/bm-notifications.html',
                controller: 'onvio.setup.notifications.BmNotificationsController as vm',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('Internal.CurrentDevelopment').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('client-notifications', {
                url: '/setup/client-notifications',
                templateUrl: 'setup/src/client-notifications/client-notifications.html',
                controller: 'onvio.setup.client.notifications.ClientNotificationsController as vm'
            });

            $stateProvider.state('setup-permission-groups', {
                url: '/setup/permission-groups',
                templateUrl: 'setup/src/permission-groups/permission-groups.html',
                resolve: {
                    permission: ['$state', 'bmPermission', 'bmAccess', 'bmLicense', function($state, bmPermission, bmAccess, bmLicense) {
                        bmPermission.has('OnvioSetup.SecurityGroups').then(function() {
                            Promise.all([
                                bmLicense.not('OnvioBR.PermissionsGroup'),
                                bmAccess.not('Brazil_NewStaffPermissionDesign')
                            ]).catch(function() {
                                $state.go('notfound', {}, { location: 'replace' });
                            });
                        }).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('ws-setup-permission-groups', {
                url: '/ws/setup/permission-groups',
                templateUrl: 'setup/src/permission-groups/permission-groups.html',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.SecurityGroups').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-permission-groups-new', {
                url: '/setup/permission-groups/new',
                templateUrl: 'setup/src/permission-groups/permission-groups-detail.html',
                resolve: {
                    permission: ['$state', 'bmPermission', 'bmAccess', 'bmLicense', function($state, bmPermission, bmAccess, bmLicense) {
                        bmPermission.has('OnvioSetup.SecurityGroups').then(function() {
                            Promise.all([
                                bmLicense.not('OnvioBR.PermissionsGroup'),
                                bmAccess.not('Brazil_NewStaffPermissionDesign')
                            ]).catch(function() {
                                $state.go('notfound', {}, { location: 'replace' });
                            });
                        }).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            // DO NOT USE - Instead use state setup-permission-groups-edit-group and URL /setup/permission-groups/edit/:groupId
            $stateProvider.state('setup-permission-groups-edit', {
                url: '/setup/permission-groups/:groupId',
                templateUrl: 'setup/src/permission-groups/permission-groups-detail.html',
                resolve: {
                    permission: ['$state', 'bmPermission', 'bmAccess', 'bmLicense', function($state, bmPermission, bmAccess, bmLicense) {
                        bmPermission.has('OnvioSetup.SecurityGroups').then(function() {
                            Promise.all([
                                bmLicense.not('OnvioBR.PermissionsGroup'),
                                bmAccess.not('Brazil_NewStaffPermissionDesign')
                            ]).catch(function() {
                                $state.go('notfound', {}, { location: 'replace' });
                            });
                        }).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-permission-groups-edit-group', {
                url: '/setup/permission-groups/edit/:groupId',
                templateUrl: 'setup/src/permission-groups/permission-groups-detail.html',
                resolve: {
                    permission: ['$state', 'bmPermission', 'bmAccess', 'bmLicense', function($state, bmPermission, bmAccess, bmLicense) {
                        bmPermission.has('OnvioSetup.SecurityGroups').then(function() {
                            Promise.all([
                                bmLicense.not('OnvioBR.PermissionsGroup'),
                                bmAccess.not('Brazil_NewStaffPermissionDesign')
                            ]).catch(function() {
                                $state.go('notfound', {}, { location: 'replace' });
                            });
                        }).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-migrations', {
                url: '/setup/migrations',
                templateUrl: 'setup/src/migrations/migration-new.html',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.hasSome(['OnvioSetup.MigrationDashboard', 'OnvioSetup.MigrateData']).then(function() {})
                            .catch(function() {
                                $state.go('notfound', {}, {location: 'replace'});
                            });
                    }]
                }
            });

            $stateProvider.state('setup-migrations-client-registration-status', {
                url: '/setup/migrations/client-registration',
                templateUrl: 'setup/src/migrations/migration-new-client-reg.html',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.MigrationDashboard').then(function() {}).catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup', {
                url: '/setup',
                template: '<ui-view/>'
            });
            bmpStateProvider.createRoute('migrationResults-master', 'setup');
            bmpStateProvider.createRoute('migrationResults-id', 'migrationResults-master');

            $stateProvider.state('setup-import-wip-transactions', {
                url: '/setup/import-wip-transactions',
                templateUrl: 'setup/src/import-wizard/import-wip.html',
                controller: 'ImportWizardController as vm',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.ImportWIP').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-import-ledger', {
                url: '/setup/import-ledger',
                templateUrl: 'setup/src/import-wizard/import-ledger.html',
                controller: 'ImportWizardController as vm',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.ImportLedgerItems').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-import-progress', {
                url: '/setup/import-progress',
                templateUrl: 'setup/src/import-progress/import-progress.html',
                controller: 'ImportProgressController as vm',
                resolve: {
                    permission: ['$q', '$state', 'bmPermission', 'bmAccess', function($q, $state, bmPermission, bmAccess) {
                        const _hasImportLedger = bmPermission.has('OnvioSetup.ImportLedgerItems')
                            .then(() => true).catch(() => false);

                        const _hasImportWip = bmPermission.has('OnvioSetup.ImportWIP')
                            .then(() => true).catch(() => false);

                        const _hasImportClient = $q.all([
                                bmPermission.has('OnvioSetup.ImportClients'),
                                bmAccess.not('HideClientImport')
                            ])
                            .then(() => true).catch(() => false);

                        $q.all(_hasImportLedger, _hasImportWip, _hasImportClient)
                            .then((hasImportLedger, hasImportWip, hasImportClient) => {
                                const hasProgress = hasImportLedger || hasImportWip || hasImportClient;
                                if (!hasProgress) {
                                    $state.go('notfound', {}, { location: 'replace' });
                                }
                            });
                    }]
                }
            });

            $stateProvider.state('import-export-test', {
                url: '/setup/import-export-test',
                templateUrl: 'setup/src/import-export-test/import-export-test.html',
                controller: 'ImportExportTestController as $ctrl',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('OnvioSetup.DataServices').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

            $stateProvider.state('setup-models', {
                url: '/setup/models',
                templateUrl: 'setup/src/models/accounting-costs/accounting-costs.html',
                controller: 'onvio.setup.models.AccountingCostsController as vm',
                params: {
                    templateId: null
                },
                resolve: {
                    permission: ['$state', 'bmAccess', function($state, bmAccess) {
                        bmAccess.not('PlatformHideModels').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });
            $stateProvider.state('add-costs-calculation', {
                url: '/setup/models/add',
                templateUrl: 'setup/src/models/add-costs-calculation/add-costs-calculation.html',
                controller: 'onvio.setup.models.AddCostsCalculationController as vm',
                params: {
                    templateId: null
                },
                resolve: {
                    permission: ['$state', 'bmAccess', function($state, bmAccess) {
                        bmAccess.not('PlatformHideModels').catch(function() {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });

        }
    ]);

    /**
     * Runs an initialization function when the 'onvio.setup' module is loaded.
     *
     * This function does the following steps:
     *
     * 1. Defines a list of restricted routes.
     * 2. Defines a 'checkNotHasPermissions' function that returns a promise that resolves if the user does not have certain permissions.
     * 3. Listens for the '$stateChangeStart' event, which is fired when a state transition begins.
     *
     * Inside the '$stateChangeStart' event handler:
     *
     * - Checks if the route the user is trying to navigate to is in the list of restricted routes.
     * - If the route is in the restricted list, then the 'checkNotHasPermissions' function is called.
     * - If the promise returned by 'checkNotHasPermissions' is rejected (which means the user has the restricted permissions),
     *   the navigation is cancelled, the user is redirected to the 'notfound' route, and a new Angular digest cycle is manually triggered
     *   by calling '$rootScope.$apply()'.
     */
    angular.module('onvio.setup').run([
        '$rootScope',
        '$location',
        'bmAccess',
        'bmLicense',
        function($rootScope, $location, bmAccess, bmLicense) {
            const restrictedRoutes = [
                'setup-staff',
                'setup-permission-groups',
                'setupEmployeeDetail.general'
            ];

            const checkNotHasPermissions = () => {
                return Promise.all([
                    bmLicense.not('OnvioBR.PermissionsGroup'),
                    bmAccess.not('Brazil_NewStaffPermissionDesign')
                ]);
            };
            $rootScope.$on('$stateChangeStart', (event, toState) => {
                    if (restrictedRoutes.includes(toState.name)) {
                        checkNotHasPermissions().then(() => {
                        }).catch(() => {
                            event.preventDefault();
                            $location.path('notfound');
                            $rootScope.$apply();
                        });
                    }
                });
        }
    ]);

})(window.angular);
